module.exports = __webpack_public_path__ + "assets/white-gov-logo-26a92c.svg";